<template>
  <am2-card-container
    :class="[
      'ar-event-card-skeleton',
      showAs,
    ]"
  >
    <ar-skeleton
      :class="[
        'left-section',
        $arMediaQuery.pageContent.maxWidth('md') && 'md-max',
      ]"
      :level="level"
    />
    <div class="right-section">
      <div class="text-bars">
        <am2-typography-skeleton
          class="text-skeleton upper"
          size="md"
          :level="level + 2"
          :style="{
            maxWidth: showAs === 'tiles' ? '400px' : '200px',
          }"
        />
        <am2-typography-skeleton
          v-if="showAs !== 'list'"
          class="text-skeleton lower"
          size="md"
          :level="level + 2"
          :style="{
            maxWidth: '250px',
          }"
        />
      </div>
      <div class="meta-bars-skeleton">
        <am2-typography-skeleton
          class="text-skeleton"
          size="xxxs"
          :level="level + 2"
          :style="{
            maxWidth: '110px',
          }"
        />
        <am2-typography-skeleton
          :class="[
            'text-skeleton',
            'u-margin-left-2',
          ]"
          size="xxxs"
          :level="level + 2"
          :style="{
            maxWidth: '60px',
          }"
        />
      </div>
    </div>
  </am2-card-container>
</template>

<script>
export default {
  name: 'EventCardSkeleton',

  props: {
    showAs: {
      type: String,
      default: 'list',
      validator: (value) =>
        ['list', 'micro-list', 'tiles'].indexOf(value) !== -1,
    },
    level: {
      type: Number,
      default: 1,
      validator: (val) => val > 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.ar-event-card-skeleton {
  display: flex;
  padding: 20px 22px;

  .right-section {
    display: flex;
    flex-flow: column;
    padding-left: 20px;
  }

  &.list {
    flex-flow: row;
    align-items: center;

    padding: 0;
    .left-section {
      flex-shrink: 0;
      width: 100%;
      border-radius: 0;
      height: 100%;
      max-width: 192px;

      &.md-max {
        max-width: 213px;
      }
    }

    .right-section {
      justify-content: space-between;
      height: 100%;
      width: 100%;
      padding: 25px 22px 12px;

      .text-bars {
        .text-skeleton {
          height: 20px;

          &.upper {
            width: 200px;
          }

          &.lower {
            width: 250px;
            margin-top: 8px;
          }
        }
      }

      .meta-bars-skeleton {
        display: flex;
        flex-direction: row;
      }
    }
  }

  &.micro-list {
    flex-flow: row;
    align-items: center;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid $skyBlueGrey400;
    padding: 0 0 8px 0;
    .left-section {
      flex-shrink: 0;
      width: 100%;
      border-radius: 0;
      height: 50%;
      max-width: 82px;
    }

    .right-section {
      justify-content: space-between;
      height: 100%;
      width: 100%;
      padding: 25px 22px 12px;

      .text-bars {
        .text-skeleton {
          height: 20px;

          &.upper {
            width: 200px;
          }

          &.lower {
            width: 250px;
            margin-top: 8px;
          }
        }
      }

      .meta-bars-skeleton {
        display: none;
      }
    }
  }

  &.tiles {
    flex-flow: column;
    align-items: center;
    padding: 0;
    justify-content: space-between;

    .text-skeleton {
      height: 20px;

      &.upper {
        width: calc(100% - 50px);
      }

      &.lower {
        width: 100%;
        margin-top: 13px;
      }
    }

    .left-section {
      width: 100%;
      padding-bottom: 50%;
      border-radius:0;
    }

    .right-section {
      margin-top: 8px;
      padding: 20px 0;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;

      .text-bars {
        width: 100%;
        padding: 0 20px;
      }

      .meta-bars-skeleton {
        width: calc(100% - 40px);
        box-sizing: border-box;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        margin: 23px 20px 0 20px !important;
        border-top: 1px solid $blueGrey400;
        padding: 22px 0 0;
      }
    }
  }

}
</style>
